import React, { useEffect, useState } from "react";
import { BiEditAlt } from "react-icons/bi";
import { MdMail } from "react-icons/md";
import { Button } from "antd";
import { AxiosCustomGet } from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import SwalToast from "../../../../components/helpers/SwalToast";
import Cookies from "js-cookie";
import moment from "moment";
import { convertEmployee } from "./helpers/convertEmployee";
import { useParams } from "react-router-dom";
import { Image } from "antd";
import { GetImage } from "../../../../components/helpers/GetImage";

function DetailEmployee({ match }) {
  const [record, setRecord] = useState({});
  const id = match.params.id;

  useEffect(() => {
    getEmployee(match.params.id);
  }, []);

  const getEmployee = (id) => {
    let url = `${process.env.REACT_APP_BASE_API_URL}employee/${id}`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setRecord(convertEmployee(response.data.data));
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  return (
    <div>
      <div style={{ padding: 24 }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: "#303030" }}>
          Lihat Detail Pegawai
        </div>
        <div
          style={{
            display: "flex",
            marginTop: 40,
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              padding: 12,
              marginRight: 12,
              height: 380,
              width: "auto",
              flex: 1,
              boxShadow: "0px 4px 12px rgba(54, 53, 53, 0.12)",
              borderRadius: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <div style={styles.title}>Informasi Personal</div>
              <div>
                <BiEditAlt /> Ubah
              </div>
            </div>
            <div style={{ display: "flex", marginTop: 24 }}>
              <GetImage
                className="image-profile"
                url={`employee/${id}/profil-picture`}
              />
              <div style={{ flex: 3, marginLeft: 24 }}>
                <div style={{ fontWeight: 600 }}>{record.name}</div>
                <div style={{ fontSize: 12 }}>
                  {record.jabatan} - {record.outlet}
                </div>
                <div style={{ fontWeight: 600, marginTop: 10 }}>
                  ID Pegawai : {record.id}
                </div>
                <Button
                  style={{
                    marginTop: 12,
                    color: "#fff",
                    background: "#2C465C",
                    borderRadius: 6,
                    width: 120,
                    height: 36,
                  }}
                >
                  <MdMail style={{ fontSize: 20, marginRight: 5 }} /> Hubungi
                </Button>
              </div>
            </div>
            <hr style={{ border: "1px dashed #DCDCDC" }} />
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <div style={styles.textLabel}>No. Telepon :</div>
              </div>
              <div style={{ flex: 3 }}>
                <div style={styles.textValue}>{record.phone}</div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <div style={styles.textLabel}>Tanggal Lahir :</div>
              </div>
              <div style={{ flex: 3 }}>
                <div style={styles.textValue}>{record.birthDate}</div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <div style={styles.textLabel}>Jenis Kelamin:</div>
              </div>
              <div style={{ flex: 3 }}>
                <div style={styles.textValue}>{record.gender}</div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <div style={styles.textLabel}>Alamat :</div>
              </div>
              <div style={{ flex: 3 }}>
                <div style={styles.textValue}>{record.address}</div>
              </div>
            </div>
          </div>
          <div style={{ flex: 1, height: 380 }}>
            <div
              style={{
                padding: 12,
                height: 164,
                width: "auto",
                boxShadow: "0px 4px 12px rgba(54, 53, 53, 0.12)",
                borderRadius: 10,
              }}
            >
              <div style={styles.title}>Pengaturan Akun</div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <div style={styles.textLabel}>Email :</div>
                </div>
                <div style={{ flex: 3 }}>
                  <div style={styles.textValue}>{record.email}</div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <div style={styles.textLabel}>Password :</div>
                </div>
                <div style={{ flex: 3 }}>
                  <div style={styles.textValue}>{"-"}</div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <div style={styles.textLabel}>Role :</div>
                </div>
                <div style={{ flex: 3 }}>
                  <div style={styles.textValue}>{record.role}</div>
                </div>
              </div>
            </div>
            <div
              style={{
                padding: 12,
                marginTop: 31,
                height: 185,
                width: "auto",
                boxShadow: "0px 4px 12px rgba(54, 53, 53, 0.12)",
                borderRadius: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                <div style={styles.title}>Kontak Darurat</div>
                <div>
                  <BiEditAlt /> Ubah
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <div style={styles.textLabel}>Nama :</div>
                  <div style={styles.textLabel}>Hubungan :</div>
                  <div style={styles.textLabel}>No. Telepon :</div>
                </div>
                <div style={{ flex: 3 }}>
                  <div style={styles.textValue}>Nama Keluarga</div>
                  <div style={styles.textValue}>Ayah</div>
                  <div style={styles.textValue}>08172371266</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: 40 }}>
          <div style={styles.title}>Riwayat Kehadiran Minggu Ini</div>
        </div>
        <div className="d-flex p-3">
          <div className="ml-auto">
            <Button
              style={{ border: "0.75px solid #DCDCDC", borderRadius: 6 }}
              type="submit"
            >
              Lihat Selengkapnya
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailEmployee;

const styles = {
  textLabel: { color: "#A6A6A6", margin: "8px 0" },
  textValue: { margin: "8px 0" },
  title: { fontSize: 14, fontWeight: 700, color: "#303030" },
};
